module.exports = __webpack_public_path__ + "img/cajatrujillo.ddb1aef.png";